import { FC, FormEvent, useRef, useState } from 'react';

import { Button } from 'antd';

import { FishFormLarge, FishFormSmall } from '@/components/ContactUs/icons';
import { FormResults } from '@/components/ContactUs/types';
import LabeledInput from '@/UI/LabeledInput';

import { PersonalDataConfirm } from '../PersonalDataConfirm';

import styles from './ContactUsForm.module.scss';

type Props = {
	loading: boolean;
	onSubmit: (args: FormResults) => Promise<void>;
	translate: (arg: string) => string;
	privacyPolicyLink: string;
	userAgreementLink: string;
};
export const Form: FC<Props> = ({
	loading,
	onSubmit,
	privacyPolicyLink,
	translate,
	userAgreementLink,
}) => {
	const [name, setName] = useState<string>('');
	const [phone, setPhone] = useState<string>('');
	const [confirm, setConfirm] = useState(false);
	const formRef = useRef<HTMLFormElement>(null);

	const handleSubmit = async (event: FormEvent) => {
		event.preventDefault();
		try {
			await onSubmit({
				name,
				phone,
			});
		} catch (e) {
			console.error('Ошибка при отрпавке формы');
		}
	};

	return (
		<form id="contact-us" className={styles.form} action="#" onSubmit={handleSubmit} ref={formRef}>
			<FishFormLarge />
			<FishFormSmall />

			<h3>{translate('contactus.contact-us')}</h3>
			<LabeledInput
				label={translate('contactus.what-is-your-name')}
				inputtype="text"
				placeholder={translate('contactus.ivanov-ivan')}
				value={name}
				onChange={(event) => setName((event.target as HTMLInputElement).value)}
			/>
			<LabeledInput
				label={translate('contactus.phone-number')}
				inputtype="tel"
				value={phone}
				onChange={(event) => setPhone((event.target as HTMLInputElement).value)}
			/>
			<PersonalDataConfirm checked={confirm} onCheckedChange={setConfirm} />
			<Button
				type="primary"
				size="large"
				disabled={!name || !phone || !confirm || loading}
				loading={loading}
				htmlType="submit"
			>
				{translate('contactus.send')}
			</Button>
			<p className={styles.formAgreement}>
				{translate('contactus.by-clicking-send-you-consent-to')}&nbsp;
				<a href={privacyPolicyLink} target="_blank" rel="noreferrer">
					{translate('contactus.privacy-policy')}
				</a>
				&nbsp;
				{translate('contactus.and')}&nbsp;
				<a href={userAgreementLink} target="_blank" rel="noreferrer">
					{translate('contactus.terms-of-use')}
				</a>
			</p>
		</form>
	);
};
